import { Form, DatePicker, Row, Col, Input, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect } from "react";

const Index = () => {
  const [form] = Form.useForm();

  const onSub = async (values) => {
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/buyer-agent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Buyer Agent"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="main">
      <Form form={form} onFinish={onSub}>
        <Row>
          <Col md={12}>
            <label>Closing Date</label>
            <Form.Item
              name="closing_date"
              rules={[{ required: true, message: "required" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Property Address</label>
            <Form.Item
              name="property_address"
              rules={[{ required: true, message: "required" }]}
            >
              <TextArea
                rows={3}
                style={{ resize: "none" }}
                placeholder="Property Address"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Seller Name</label>
            <Form.Item
              name="seller_name"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Seller Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Buyer Name</label>
            <Form.Item
              name="buyer_name"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Buyer Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Selling Brokerage</label>
            <Form.Item
              name="selling_brokerage"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Selling Brokerage" />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Selling Broker & License #</label>
            <Form.Item
              name="selling_broker"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Selling Broker" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Listing Brokerage</label>
            <Form.Item
              name="listing_brokerage"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Listing Brokerage" />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Listing Broker & License # (if available)</label>
            <Form.Item
              name="listing_broker"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Listing Broker" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row gutter={16}>
          <Col md={12}>
            <label>1) Contract Purchase Price</label>
            <Form.Item
              name={"contract_purchase_price"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="$" />
            </Form.Item>
            <label>2) Commissionable Net Sales Price</label>
            <Form.Item
              name={"commissionable_net_sales_price"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="$" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>
              3) Buyer contribution towards buyer broker compensation
            </label>
            <Form.Item
              name={"buyer_broker_fee"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="$" />
            </Form.Item>
            <label>4) Seller Commission to Vicente Realty</label>
            <Form.Item
              name={"seller_commission"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="$" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>5) Total commission compensation to Vicente Realty</label>
            <Form.Item
              name={"total_commission_vicenta_realty"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="$" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row gutter={16}>
          <Col md={12}>
            <label>Federal Tax ID</label>
            <Form.Item name="federal_tax_id" initialValue={"45-3673820"}>
              <Input readOnly />
            </Form.Item>

            <label>MA Real Estate Board License</label>
            <Form.Item
              name="ma_real_estate_board_license"
              initialValue={"9799"}
            >
              <Input readOnly />
            </Form.Item>
            <label>MA Broker’s License</label>
            <Form.Item name="ma_broker_license" initialValue={"9519238"}>
              <Input />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>RI Broker’s License</label>
            <Form.Item name="ri_broker_license" initialValue={"REB.0018693"}>
              <Input />
            </Form.Item>
            <label>MLSPIN ID</label>
            <Form.Item name="mlspin_id" initialValue={"1033"}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
